import { render, staticRenderFns } from "./WidgetLatestArticles.vue?vue&type=template&id=e59e18b2&scoped=true"
import script from "./WidgetLatestArticles.vue?vue&type=script&lang=js"
export * from "./WidgetLatestArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59e18b2",
  null
  
)

export default component.exports